import * as yup from 'yup';


export const commonPaymentModeForPoValidation: { [x: string]: any; } = {
  paymentMode: yup.string().required("Missing."),
  paymentAmount: yup.number().required("Missing."),
  payOrderAmount: yup.number().required("Missing."),
  payOrderNo: yup.string().required("Missing."),
  bankCode: yup.string().required("Missing."),
};
export const commonPaymentModeForCashValidation: { [x: string]: any; } = {
  paymentMode: yup.string().required("Missing."),
  paymentAmount: yup.number().required("Missing."),
};
export const commonPaymentModeForPosValidation: { [x: string]: any; } = {
  paymentMode: yup.string().required("Missing."),
  paymentAmount: yup.number().required("Missing."),
  creditCardNo: yup.string().required("Missing."),
};
export const commonPaymentModeHeaderValidation: { [x: string]: any; } = {
  agentDeliveryDate: yup.date().required("Missing."),
  customsDeclarationDate: yup.date().required("Missing."),
  customsDeclarationNo: yup.string().required("Missing."),
};
export const commonPaymentModeHeaderForAgentValidation: { [x: string]: any; } = {
  agentDeliveryDate: yup.date().required("Missing."),
};
export const commonPaymentModeHeaderForCustomsValidation: { [x: string]: any; } = {
  customsDeclarationDate: yup.date().required("Missing."),
  customsDeclarationNo: yup.string().required("Missing."),
};
export const commonPaymentModeHeaderForAQCTIBValidation: { [x: string]: any; } = {
  agentDeliveryDate: yup.date().required("Missing."),
  shippingAgent: yup.string().required("Missing."),
};

export const commonPaymentModeHeaderForAQCTOBValidation: { [x: string]: any; } = {
  shippingAgent: yup.string().required("Missing."),
};
export const commonPaymentModeForOnlineValidation: { [x: string]: any; } = {
  paymentMode: yup.string().required("Missing."),
  paymentAmount: yup.number().required("Missing."),
  creditCardNo: yup.string().required("Missing."),
  payOrderNo: yup.string().required("Missing."),
};

export const createPaymentModeForPoValidation: { [x: string]: any; } = {
  ...commonPaymentModeForPoValidation,
};
export const createPaymentModeForPosValidation: { [x: string]: any; } = {
  ...commonPaymentModeForPosValidation,
};
export const createPaymentModeForCashValidation: { [x: string]: any; } = {
  ...commonPaymentModeForCashValidation,
};
export const createPaymentModeHeaderValidation: { [x: string]: any; } = {
  ...commonPaymentModeHeaderValidation,
};
export const createPaymentModeHeaderForAgentValidation: { [x: string]: any; } = {
  ...commonPaymentModeHeaderForAgentValidation,
};
export const createPaymentModeHeaderForCustomsValidation: { [x: string]: any; } = {
  ...commonPaymentModeHeaderForCustomsValidation,
};
export const createPaymentModeHeaderForAQCTIBValidation: { [x: string]: any; } = {
  ...commonPaymentModeHeaderForAQCTIBValidation,
};
export const createPaymentModeHeaderForAQCTOBValidation: { [x: string]: any; } = {
  ...commonPaymentModeHeaderForAQCTOBValidation,
};

export const createPaymentModeForPoValidationSchema = yup.object().shape(createPaymentModeForPoValidation);
export const createPaymentModeForPosValidationSchema = yup.object().shape(createPaymentModeForPosValidation);
export const createPaymentModeForCashValidationSchema = yup.object().shape(createPaymentModeForCashValidation);
export const createPaymentModeForOnlineValidationSchema = yup.object().shape(commonPaymentModeForOnlineValidation);
export const createPaymentModeHeaderValidationSchema = yup.object().shape(createPaymentModeHeaderValidation);
export const createPaymentModeHeaderForAgentValidationSchema = yup.object().shape(createPaymentModeHeaderForAgentValidation);
export const createPaymentModeHeaderForCustomsValidationSchema = yup.object().shape(createPaymentModeHeaderForCustomsValidation);
export const createPaymentModeHeaderForAQCTIBValidationSchema = yup.object().shape(createPaymentModeHeaderForAQCTIBValidation);
export const createPaymentModeHeaderForAQCTOBValidationSchema = yup.object().shape(createPaymentModeHeaderForAQCTOBValidation);

